var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-loader transition",style:({'width': _vm.progressLoaderWidth + '%'}),attrs:{"id":"progress-loader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }